module.exports = __webpack_public_path__ + "static/media/ubicuologo.7e46abf9.png";